import React, { useCallback, useImperativeHandle, useRef, useState } from 'react';

import GridPopup from '@bo-components/common/grid/GridPopup';
import GridContainer from '@bo-components/common/grid/GridContainer';
import {
  gridPropTypes,
  handleGridFunctionPropTypes,
  IBSheetEventPropTypes,
  leftHeaderButtonPropTypes,
  pagingPropTypes,
  rightHeaderButtonPropTypes,
  uploadPopupPropTypes,
} from '@bo-components/common/grid/gridPropTypes';

const Grid = React.forwardRef(({ onPopupSave, uploadPopupProps, children, sizeEnl, ...props }, ref) => {
  const [uploadPopupOpen, setUploadPopupOpen] = useState(false);
  const gridRef = useRef(null);
  const popupRef = useRef(null);
  const renderSafeJobsRef = useRef([]);

  useImperativeHandle(ref, () => gridRef.current);

  const handleExcelUploadClick = () => {
    setUploadPopupOpen(true);
  };

  const hideUploadPopup = () => {
    setUploadPopupOpen(false);
  };

  const renderSafeJobs = useCallback(() => {
    return renderSafeJobsRef.current;
  }, []);

  return (
    <>
      <GridContainer
        handleExcelUploadClick={handleExcelUploadClick}
        renderSafeJobs={renderSafeJobs}
        sizeEnl={sizeEnl}
        {...props}
        ref={gridRef}
      >
        {children}
      </GridContainer>
      <GridPopup
        uploadPopupOpen={uploadPopupOpen}
        hideUploadPopup={hideUploadPopup}
        onSave={onPopupSave}
        reloadData={gridRef?.current?.reloadData}
        {...props}
        {...uploadPopupProps}
        ref={popupRef}
      />
    </>
  );
});

Grid.propTypes = {
  ...gridPropTypes,
  /* UploadPopup custom props */
  ...uploadPopupPropTypes,
  /* LeftHeaderButtons */
  ...leftHeaderButtonPropTypes,
  /* RightHeaderButtons */
  ...rightHeaderButtonPropTypes,
  /* Paging */
  ...pagingPropTypes,
  /* Handle Functions */
  ...handleGridFunctionPropTypes,
  /* IBSheet Event */
  ...IBSheetEventPropTypes,
};

Grid.defaultProps = {
  data: [],
  options: {},
  initRow: {},
  title: 'Table',
  validators: {},
  addRowLabel: '행추가',
  numberOfPageGroup: 10,
  height: '275px',
  saveButtonLabel: '저장',
  saveButtonWidth: '90px',
};

Grid.displayName = 'Grid';

export default Grid;
